import { forwardRef, useState, useRef, useImperativeHandle, useEffect } from 'react';
import styled from 'styled-components';

import { useLanguage } from '../../Context/LanguageContext';

import SelectOnPath from '../../image/SelectOn.png';
import SelectOffPath from '../../image/SelectOff.png';

const SignUpSelectBox = forwardRef((props, ref) => {
	const { t } = useLanguage();

	const [isClicked, setIsClicked] = useState(false);
	const [defaultVal, setDefaultVal] = useState({ value: 'PT', text: '' });

	const SelectRef = useRef();

	const options = [
		{ value: 'PT', text: t('signUp.centerTypes.pt') },
		{ value: 'groupTraining', text: t('signUp.centerTypes.groupTraining') },
		{ value: 'boutiqueFitness', text: t('signUp.centerTypes.boutiqueFitness') },
		{ value: 'normalFitness', text: t('signUp.centerTypes.normalFitness') },
		{ value: 'pilates', text: t('signUp.centerTypes.pilates') },
		{ value: 'yoga', text: t('signUp.centerTypes.yoga') },
		{ value: 'crossfit', text: t('signUp.centerTypes.crossfit') },
		{ value: 'basketball', text: t('signUp.centerTypes.basketball') },
		{ value: 'tennis', text: t('signUp.centerTypes.tennis') },
		{ value: 'baseball', text: t('signUp.centerTypes.baseball') },
		{ value: 'soccer', text: t('signUp.centerTypes.soccer') },
		{ value: 'spinning', text: t('signUp.centerTypes.spinning') },
		{ value: 'ballet', text: t('signUp.centerTypes.ballet') },
		{ value: 'boxing', text: t('signUp.centerTypes.boxing') },
		{ value: 'dance', text: t('signUp.centerTypes.dance') },
		{ value: 'golf', text: t('signUp.centerTypes.golf') },
		{ value: 'other', text: t('signUp.centerTypes.other') },
	];

	// 언어 변경 시 기본값 갱신 //
	useEffect(() => {
		setDefaultVal({ value: 'PT', text: t('signUp.centerTypes.pt') });
	}, [t]);

	// SelectBox 바깥 클릭 시 닫기 //
	useEffect(() => {
		function handleOutsideClick(e) {
			if (!isClicked) return;

			if (SelectRef.current && !SelectRef.current.contains(e.target)) {
				SelectRef.current.style.border = '1px solid #CBCBCB';
				SelectRef.current.style.height = '34px';
				SelectRef.current.style.overflow = 'hidden';
				setIsClicked(false);
			}
		}

		document.addEventListener('mousedown', handleOutsideClick);

		return () => {
			document.removeEventListener('mousedown', handleOutsideClick);
		};
	}, [isClicked]);

	useImperativeHandle(ref, () => ({
		getValue: () => {
			return defaultVal.text;
		}
	}))

	// SelectBox 열기/닫기 //
	function onClickSelectBox() {
		if (isClicked) {
			SelectRef.current.style.border = '1px solid #CBCBCB';
			SelectRef.current.style.height = `40px`;
			SelectRef.current.style.overflow = 'hidden';
			setIsClicked(false);
		}
		else {
			SelectRef.current.style.border = '1px solid #FF8B48';
			SelectRef.current.style.height = `240px`;
			SelectRef.current.style.overflowY = 'scroll';
			SelectRef.current.style.overflowX = 'none';
			setIsClicked(true);
		}
	}

	// 옵션 선택 //
	function onClickOption(index) {
		setDefaultVal(options[index]);
	}

	return (
		<TopLevelWrapper>
			<SelectBox
				ref={SelectRef}
				isClicked={isClicked}
				buttonPath={isClicked ? SelectOnPath : SelectOffPath}
				onClick={onClickSelectBox}>
				{
					isClicked ?
						options.map((data, index) =>
							<OptionWrapper
								key={'CenterType-' + index}
								onClick={() => onClickOption(index)}>
								<Option isSelected={data.value === defaultVal.value && data.text === defaultVal.text}>{data.text}</Option>
							</OptionWrapper>
						)
						:
						<OptionWrapper>
							<Option>{defaultVal.text}</Option>
						</OptionWrapper>
				}
			</SelectBox>
		</TopLevelWrapper>
	)
})

export default SignUpSelectBox;

const TopLevelWrapper = styled.div`
	display: flex;
	flex-direction: column;
	
	width: 200px;
	height: 34px;
	// height: max(32px, 1.979166666666667vw);

	margin-top: 10px;
	// margin-top: max(12.27px, 0.6770833333333333vw);
`;

const SelectBox = styled.div`
	position: absolute;
	display: flex;
	flex-direction: column;

	justify-content: ${props => props.isClicked ? 'flex-start' : 'center'};
	align-items: flex-start;

	width: 200px;
	height: 34px;
	// height: max(32px, 1.979166666666667vw);

	border: 1px solid #777777;
	border-radius: 8px;
	overflow: hidden;

	z-index: 2;

  background: url(${props => props.buttonPath}) no-repeat 96% ${props => props.isClicked ? `3` : `55`}%;
	background-color: rgba(255, 255, 255, 1);
  transition: all 0.3s ease-in-out;

	&:hover {
		cursor: pointer;
	}

	&::-webkit-scrollbar {
		width: 9px;
	}

	&::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 10px 20px #FF8B48;
		border: 3px solid transparent;
		height: 25px;
		// background-color: #FF8B48;
		border-radius: 200px;
	}

	&::-webkit-scrollbar-track {
    box-shadow: inset 0 0 10px 10px transparent;
		border: 4px solid transparent;
		background-color: transparent;
	}

	&::-webkit-scrollbar-track-piece {
		background-color: transparent;
	}
`;

const OptionWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;

	&:hover {
		cursor: pointer;
	}
`;

const Option = styled.p`
	font-family: NotoSansKR-Regular;
	font-size: 16px;
	// font-size: max(12px, 0.7291666666666667vw);
	margin: 10px 0 10px 13px;
	// margin-top: max(6px, 0.5208333333333333vw);
	// margin-right: 0px;
	// margin-bottom: max(9px, 0.5208333333333333vw);
	// margin-left: max(12px, 0.6770833333333333vw);

	color: ${props => props.isSelected ? '#FF8B48' : '#333333'};
`;